// iter247 — Single source of truth for the 4 optional "sale method"
// chips a lister can attach to their ad. Backend whitelists on the
// same ids in server.py (VehicleIn/VehicleUpdate.sale_options).
// AR/EN labels + a compact emoji glyph. No other options are allowed.
export const SALE_OPTIONS = [
  { id: "financing",          glyph: "💳", ar: "تمويل / تقسيط",              en: "Financing / installments" },
  { id: "leasing",            glyph: "🏠", ar: "تأجير منتهي بالتمليك",       en: "Lease-to-own" },
  { id: "direct_installment", glyph: "🧾", ar: "تقسيط مباشر من الشركة",      en: "Direct installments" },
  { id: "trade_in",           glyph: "🔄", ar: "استبدال سيارة",              en: "Car trade-in" },
  // iter277 — additive-only. Backend whitelist widened in the same
  // change to accept "cash" so both create + update paths persist it.
  { id: "cash",               glyph: "💵", ar: "كاش",                        en: "Cash" },
];

export const SALE_OPTIONS_INDEX = Object.fromEntries(
  SALE_OPTIONS.map((o) => [o.id, o])
);
